import type { IconSvgObject } from './types';

const CornIcon: IconSvgObject = [
  ["path", { d: "M3.88481 20.1321C5.98804 22.2097 9.86304 21.7503 12.5399 19.1062C15.5988 16.0848 17.3891 15.1197 18.5 14.5C14.8912 10.9354 8.75783 13.0463 8.10703 17.75M3.88481 20.1321L2.5 21.5M3.88481 20.1321C1.78158 18.0546 2.24717 14.2277 4.92401 11.5836C5.77111 10.956 7.845 8.90241 8.10703 6.49988C9.41142 7.78831 10.607 8.99988 10.107 11.5836", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5917 13C19.9418 9.37568 22.5321 4.72423 21.0791 3.04556C19.3481 1.04574 14.0084 4.93844 10 8.33662", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornIcon;
